// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessBonus_wrapper--aKt","createWallet":"SuccessBonus_createWallet--xWL","createWalletText":"SuccessBonus_createWalletText--KpU"};